import React from 'react';

const CustomerSection = ({
  selectedCustomer,
  getCustomerDisplayName,
  getCustomerAddress,
  onOpenModal,
  onClear,
}) => (
  <div style={{
    backgroundColor: 'var(--bg)',
    borderRadius: '4px',
    padding: '0.5rem',
    marginBottom: '0.5rem',
    border: '1px solid var(--border)',
  }}>
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.4rem',
    }}>
      <div style={{ fontSize: '11px', fontWeight: '600' }}>&#x1F464; Odbiorca</div>
      {!selectedCustomer && (
        <button
          onClick={onOpenModal}
          style={{
            padding: '4px 10px',
            fontSize: '11px',
            fontWeight: '500',
            border: '1px solid var(--info)', color: 'var(--info)' ,
            cursor: 'pointer',
          }}
        >
          &#x1F465; Wybierz klienta
        </button>
      )}
    </div>

    {selectedCustomer ? (
      <div style={{
        backgroundColor: 'var(--card-bg)',
        padding: '0.5rem',
        borderRadius: '4px',
        border: '1px solid var(--success)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontWeight: '600', fontSize: '12px', color: 'var(--success)' }}>
              &#x2705; {getCustomerDisplayName(selectedCustomer)}
            </div>
            {selectedCustomer.nip && (
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px' }}>
                NIP: {selectedCustomer.nip}
              </div>
            )}
            {(selectedCustomer.email || selectedCustomer.telefon) && (
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px' }}>
                {selectedCustomer.email && `📧 ${selectedCustomer.email}`}
                {selectedCustomer.email && selectedCustomer.telefon && ' • '}
                {selectedCustomer.telefon && `📞 ${selectedCustomer.telefon}`}
              </div>
            )}
            {getCustomerAddress(selectedCustomer) && (
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px' }}>
                &#x1F4CD; {getCustomerAddress(selectedCustomer)}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '0.3rem' }}>
            <button
              onClick={onOpenModal}
              style={{
                padding: '4px 10px',
                fontSize: '11px',
                border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
                cursor: 'pointer',
              }}
            >
              &#x270F;&#xFE0F;
            </button>
            <button
              onClick={onClear}
              style={{
                padding: '4px 10px',
                fontSize: '11px',
                border: '1px solid var(--danger)', color: 'var(--danger)' ,
                cursor: 'pointer',
              }}
            >
              &#x2715;
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div style={{
        backgroundColor: 'var(--warning-light)',
        padding: '0.5rem',
        borderRadius: '4px',
        fontSize: '10px',
        color: 'var(--warning)',
        textAlign: 'center',
      }}>
        &#x26A0;&#xFE0F; Nie wybrano odbiorcy. Kliknij &quot;Wybierz klienta&quot; powy&#x17C;ej.
      </div>
    )}
  </div>
);

export default CustomerSection;
